import type { EntityRegistry } from '@sites/entity-migrator';

import { DefaultTabEntityVersionedSchema, type TabEntity } from './schemas';

export const tabRegistry: EntityRegistry<TabEntity> = {
    name: 'tab',
    getEntitySchema: (entity: unknown, ctx) => {
        if (typeof entity !== 'object' || entity === null) return null;
        const subType = (entity as { entitySubType?: unknown }).entitySubType;
        if (subType === 'default') return DefaultTabEntityVersionedSchema;
        return null;
    },
};
